import styled from 'styled-components';

export const InstallNudgeContainer = styled.div`
  display: none;

  &.consultationNudge {
    display: block;
    width: 100%;
    position: ${(props) => (props.wrapStrip ? 'fixed' : 'unset')} !important;

    &.transitionToggle {
      top: 65px;
    }

    top: 0px;
    padding: 0;
    display: flex;
    align-items: center;
    z-index: 91;
    transition: all 0.3s linear;
    @media (min-width: 768px) {
      top: 88px;
      margin-bottom: 9px;
      margin-left: -8.5vw;
      width: 100vw;
      height: 36px;
      display: ${(props) => (props.hideOnDesktop ? 'none' : 'flex')};
    }

    @media (max-width: 768px) {
      height: auto !important;
      line-height: unset !important;
      margin-bottom: 20px;
    }
  }

  @media (max-width: 720px) {
    background-color: #e6f2f1;
    height: 36px;
    line-height: 36px;
    width: 100%;
    position: ${(props) => (props.articlePage ? 'fixed' : 'sticky')};
    top: 65px;
    display: flex;
    align-items: center;
    z-index: 91;
    padding: 2px 16px;
  }
`;

export const Cross = styled.span`
  font-size: 10px;
  font-weight: 600;
  color: hsl(0deg, 0%, 0%, 60%);
  margin-right: 10px;
`;

export const NudgeTitle = styled.span`
  font-size: 11px;
  font-weight: 600;
  color: hsl(0deg, 0%, 0%, 56%);
`;

export const MobilePopup = styled.div`
  display: none;

  @media (max-width: 720px) {
    display: block;
  }
`;

export const MobilePopupImage = styled.img`
  width: 100%;
  height: auto;
`;

export const ButtonContainer = styled.div`
  padding: 0px 20px 20px 20px;
`;

export const ReadMoreLine = styled.p`
  font-size: 15px;
  font-weight: 500;
  color: hsl(0deg, 0%, 0%, 60%);
  padding: 20px 17px;
`;

export const ContinueAppButton = styled.button`
  outline: none;
  border: 1px solid #ef4e5e;
  background: #ef4e5e;
  color: #fff;
  width: 100%;
  height: 42px;
  text-align: center;
  font-size: 14px;
  font-weight: 500;
  font-family: 'Montserrat';
  border-radius: 4px;
  position: relative;
  transition: background 0.15s ease-in-out;

  span {
    position: absolute;
    opacity: 0;
    top: 0;
    left: 0;
    background: linear-gradient(
      to right,
      rgba(255, 255, 255, 0) 0%,
      rgba(255, 255, 255, 0.03) 1%,
      rgba(255, 255, 255, 0.6) 30%,
      rgba(255, 255, 255, 0.85) 50%,
      rgba(255, 255, 255, 0.85) 70%,
      rgba(255, 255, 255, 0.85) 71%,
      rgba(255, 255, 255, 0) 100%
    );
    width: 20%;
    height: 100%;
    animation: move_continue 2s;
    animation-iteration-count: infinite;
    animation-delay: 1s;
  }

  @keyframes move_continue {
    0% {
      left: 0;
      opacity: 0;
    }
    5% {
      opacity: 0;
    }
    48% {
      opacity: 0.2;
    }
    80% {
      opacity: 0;
    }
    100% {
      left: 82%;
    }
  }
`;

export const InstallNudgeElseDiv = styled.div`
  height: 35px;
  padding-bottom: 24px;
`;
